import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import BatteryBanner from "@/components/site/BatteryBanner";
import Gallery from "@/components/site/Gallery";
import Reviews from "@/components/site/Reviews";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";
import Admin from "@/pages/Admin";

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain bg-[#0A0A0A] text-white selection:bg-[#39FF14] selection:text-black">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <BatteryBanner />
        <Gallery />
        <Reviews />
        <Booking />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}
